import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/82_card_back_halloween_mushroom/82_card_back_halloween_mushroom"
 * Contains 1 texture(s)
 */
export class CardsBacks82CardBackHalloweenMushroomAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/82_card_back_halloween_mushroom/82_card_back_halloween_mushroom';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '82_halloween_mushroom.png'
    ] as const;
}
